import React from 'react';
import Icon from '../shared/components/Icon';
import { Link } from '../../features/ui';
import ios from './footer-ios.svg';
import android from './footer-android.svg';

const year = new Date().getFullYear();

const TRACK_CAT = 'Footer';

export default function Footer() {
  return (
    <footer className="footer footer-default" role="contentinfo">
      <div className="container">
        <nav className="row">
          <div className="col-xs-12 col-md-2">
            <div className="footer-logo">
              <Link
                external
                href="https://www.spotify.com"
                track={[TRACK_CAT, 'Logo']}
              >
                Spotify
              </Link>
            </div>
          </div>
          <div className="col-xs-12 col-sm-4 col-md-2">
            <h3 className="nav-title">Helpful Links</h3>
            <ul className="nav">
              <li>
                <Link
                  external
                  href="https://www.spotify.com/about-us/contact/"
                  track={[TRACK_CAT, 'About']}
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  external
                  href="https://newsroom.spotify.com"
                  track={[TRACK_CAT, 'Press & Media']}
                >
                  Press &amp; Media
                </Link>
              </li>
              <li>
                <Link
                  href="/contact"
                  data-testid="footer-contact"
                  track={[TRACK_CAT, 'Contact Us']}
                  prefetch={false}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-xs-12 col-sm-4 col-md-2">
            <h3 className="nav-title">Creator Tools</h3>
            <ul className="nav">
              <li>
                <Link
                  external
                  href="https://app.adjust.com/iya18ah?redirect=https%3A%2F%2Fanchor.fm%2Fapp"
                  track={[TRACK_CAT, 'Creator Tools - Anchor']}
                >
                  Anchor
                </Link>
              </li>
              <li>
                <Link
                  external
                  href="https://soundbetter.com/"
                  track={[TRACK_CAT, 'Creator Tools - SoundBetter']}
                >
                  SoundBetter
                </Link>
              </li>
              <li>
                <Link
                  external
                  href="https://www.soundtrap.com/?utm_source=spotify_site&utm_medium=footer_menulink&utm_campaign=alwayson_global_soundtrap_destination"
                  track={[TRACK_CAT, 'Creator Tools - Soundtrap']}
                >
                  Soundtrap
                </Link>
              </li>
              <li>
                <Link
                  external
                  href="https://podcasters.spotify.com/?utm_source=artists.spotify.com"
                  track={[TRACK_CAT, 'Creator Tools - Spotify for Podcasters']}
                >
                  Spotify for Podcasters
                </Link>
              </li>
              <li>
                <Link
                  external
                  href="https://publishers.spotify.com/?utm_source=artists.spotify.com"
                  track={[
                    TRACK_CAT,
                    'Creator Tools - Spotify Publishing Analytics',
                  ]}
                >
                  Spotify Publishing Analytics
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-xs-12 col-sm-4">
            <h3 className="nav-title">Get the app</h3>
            <Link
              external
              href="https://itunes.apple.com/us/app/spotify-for-artists/id1222021797"
              track={[TRACK_CAT, 'iOS App']}
            >
              <img
                style={{ width: '170px' }}
                src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                data-src={ios}
                className="lazyload"
                alt="Download banner for iOS"
              />
            </Link>
            <Link
              external
              href="https://play.google.com/store/apps/details?id=com.spotify.s4a"
              track={[TRACK_CAT, 'Andorid App']}
            >
              <img
                style={{ width: '170px', marginTop: '12px' }}
                src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                data-src={android}
                className="lazyload"
                alt="Download banner for Android"
              />
            </Link>
          </div>
          <div className="col-xs-12 col-md-2 col-social">
            <ul className="nav">
              <li>
                <Link
                  external
                  href="https://twitter.com/spotifyartists"
                  track={[TRACK_CAT, 'Social - Twitter']}
                >
                  <Icon name="twitter-icon" className="social-icon" />
                  <span className="social-text">Twitter</span>
                </Link>
              </li>
              <li>
                <Link
                  external
                  href="https://www.instagram.com/spotifyforartists/"
                  track={[TRACK_CAT, 'Social - Instagram']}
                >
                  <Icon name="instagram-icon" className="social-icon" />
                  <span className="social-text">Instagram</span>
                </Link>
              </li>
            </ul>
          </div>
        </nav>

        <nav className="row row-small">
          <div className="col-xs-7 col-md-4 col-md-offset-2">
            <ul className="nav nav-small">
              <li>
                <Link
                  external
                  href="https://www.spotify.com/us/legal/spotify-for-artists-terms-and-conditions/"
                  track={[TRACK_CAT, 'Legal']}
                >
                  Legal
                </Link>
              </li>
              <li>
                <Link
                  external
                  href="https://www.spotify.com/legal/privacy-policy/"
                  track={[TRACK_CAT, 'Privacy Policy']}
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  external
                  href="https://www.spotify.com/legal/privacy-policy/#s13"
                  track={[TRACK_CAT, 'Cookies']}
                >
                  Cookies
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-xs-5 col-md-6 text-right">
            <small className="copyright">&copy; {year} Spotify AB</small>
          </div>
        </nav>
      </div>
    </footer>
  );
}
